import { connect } from "react-redux";
import Create from "./Create";
import { actions } from "../../../../redux/modules/shuttle";


const mstp = (state) => state.shuttle;

export default connect(mstp, actions)(Create);
